import {
  Image,
  Box,
  Flex,
  Heading,
  Stack,
  Text,
  Button,
  TableContainer,
  Table,
  Thead,
  Td,
  Tr,
  Th,
  Tbody,
  HStack,
  Avatar,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  IconButton
} from "@chakra-ui/react";
import React from "react";
import CommonContainer from "../../../components/shared/CommonContainer";
import { useNavigate } from "react-router-dom";
import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai";

export default function FreelancerOrderPage() {
  const [tab, setTab] = React.useState("Priority");
  const tabBtnListRef = React.useRef();
  const prevSelected = () => {
    let newSelection = linksData.indexOf(tab);

    return linksData[
      newSelection === 0 ? linksData.length - 1 : newSelection - 1
    ];
  };
  const prevClickHandler = () => {
    let indexOfPrev = linksData.indexOf(tab);
    let newIndexOfPrev =
      indexOfPrev === 0 ? linksData.length - 1 : indexOfPrev - 1;
    setTab(linksData[newIndexOfPrev]);
    tabBtnListRef.current.children[newIndexOfPrev].click();
  };
  const nextSelected = () => {
    let newSelection = linksData.indexOf(tab);

    return linksData[
      newSelection === linksData.length - 1 ? 0 : newSelection + 1
    ];
  };
  const nextClickHandler = () => {
    let indexOfPrev = linksData.indexOf(tab);
    let newIndexOfPrev =
      indexOfPrev === linksData.length - 1 ? 0 : indexOfPrev + 1;
    setTab(linksData[newIndexOfPrev]);
    tabBtnListRef.current.children[newIndexOfPrev].click();
  };
  return (
    <CommonContainer>
      <Stack my={{ base: 10, lg: 20 }}>
        <Heading
          fontWeight={"semibold"}
          fontSize={{ base: "21px", md: "26px" }}
          pb={{ base: 5, lg: 10 }}
        >
          Manage Orders
        </Heading>
        <Flex
          justifyContent="space-between"
          alignItems="start"
          mb={10}
          display={{ base: "none", xl: "flex" }}
        >
          <Box
            fontSize={{ base: "14px", lg: "18px" }}
            w={{ xl: "10%" }}
            pr={1}
            fontWeight="medium"
          >
            {linksData.map((item, index) => {
              return (
                <Text
                  mb={3}
                  color={tab === item.label ? "brand.500" : "#c5c5c5"}
                  cursor="pointer"
                  onClick={() => {
                    setTab(item);
                  }}
                  key={index}
                >
                  {item}
                </Text>
              );
            })}
          </Box>
          <Box
            px={{ base: 5, md: 10, xl: 20 }}
            fontSize={{ md: "19px" }}
            w={{ xl: "90%" }}
            borderLeft="1px"
            borderColor="#707070"
            minH="300px"
          >
            <Box
              border="1px solid #c5c5c5"
              borderRadius={"5px"}
              overflow="hidden"
            >
              <Flex
                bg="#f4f4f4"
                justifyContent="space-between"
                p={4}
                fontWeight="medium"
              >
                <Text
                  fontSize={{ base: "18px", lg: "26px" }}
                  fontWeight="semibold"
                >
                  {tab} Orders
                </Text>
              </Flex>
              <OrderTable />
            </Box>
          </Box>
        </Flex>
        {/* Mobile version */}
        <Tabs variant="" isFitted display={{ base: "block", xl: "none" }}>
        <Flex pos="relative" display={{ base: "flex", sm: "none" }} justifyContent={"center"} overflow="hidden">
          <Button
          fontSize="12px"
            _selected={{ color: "white", bg: "brand.500" }}
            bg="#f1f1f1"
            w="full"
            border="1px solid #c5c5c5"
            borderLeft={0}
            borderTop={0}
            fontWeight={500}
            sx={{ py: 4 }}
            minW="120px"
            rounded="none"
            height="full"
          >
            {prevSelected()}
          </Button>
          <Button
          fontSize="12px"
            rounded="none"
            bg="brand.500"
            color="white"
            w="full"
            border="1px solid #c5c5c5"
            borderLeft={0}
            borderTop={0}
            fontWeight={500}
            sx={{ py: 4 }}
            minW="120px"
            height="full" 
          >
            {tab}
          </Button>
          <Button
          fontSize="12px"
            bg="#f1f1f1"
            w="full"
            border="1px solid #c5c5c5"
            borderLeft={0}
            borderTop={0}
            fontWeight={500}
            sx={{ py: 4 }}
            minW="120px"
            rounded="none"
            height="full"
            
          >
            {nextSelected()}
          </Button>
          <IconButton
            pos="absolute"
            left="0"
            height="full"
            background={"none"}
            _hover={{bgGradient:"linear(to-r,rgba(241,241,241,100)20%,rgba(241,241,241,0))"}}
            borderBottom="1px"  
            rounded="none"
            borderColor="#c5c5c5"
            justifyContent="start"
            bgGradient="linear(to-r,rgba(241,241,241,100)20%,rgba(241,241,241,0))"
            w="50px"
            pr={1}
            onClick={prevClickHandler}
          >
            <AiOutlineLeft />
          </IconButton>
          <IconButton
            pos="absolute"
            right={0}
            justifyContent="end"
            m={0}
            height="full"
            background={"none"}
            _hover={{bgGradient:"linear(to-r,rgba(241,241,241,0)30%,rgba(241,241,241,100)70%)"}}

            borderBottom="1px"
            rounded="none"
            borderColor="#c5c5c5"
            bgGradient="linear(to-r,rgba(241,241,241,0)30%,rgba(241,241,241,100)70%)"
            w="50px"
            pr={1}
            onClick={nextClickHandler}
          >
            <AiOutlineRight />
          </IconButton>
        </Flex>
          <TabList overflow="auto" ref={tabBtnListRef} display={{ base: "none", sm: "flex" }}>
            {linksData.map((item) => {
              return (
                <Tab
                  _selected={{ color: "white", bg: "brand.500" }}
                  bg="#f4f4f4"
                  onClick={() => {
                    setTab(item);
                  }}
                  key={item}
                >
                  {item}
                </Tab>
              );
            })}
          </TabList>
          <TabPanels>
            {linksData.map((item, index) => {
              return (
                <TabPanel px={0} key={index}>
                  <Box
                    borderRadius={10}
                    overflow="hidden"
                    border="1px solid #c5c5c5"
                  >
                    <HStack bg="#f4f4f4" justifyContent="space-around">
                      {/* <AiOutlineLeft /> */}
                      <Text p={4} fontWeight="medium">
                        {tab} Orders
                      </Text>
                      {/* <AiOutlineRight /> */}
                    </HStack>
                    <TableContainer minH="150px" w="full">
                      <Table>
                        <Tbody>
                          {["Buyer", "Gig", "Due On", "Total", "Status"].map(
                            (item, index) => {
                              return (
                                <Tr key={index}>
                                  <Td
                                    fontWeight="medium"
                                    fontSize={{ base: "12px", md: "20px" }}
                                    color="#c5c5c5"
                                    px={2}
                                    borderRight="1px solid #c5c5c5"
                                  >
                                    {item}
                                  </Td>
                                  {index === 0 && (
                                    <Td px={2}>
                                      <HStack>
                                        <Avatar
                                          src="/images/freelancer/profiles/7.png"
                                          size={{ base: "sm", md: "lg" }}
                                        />
                                        <Text
                                          fontWeight={"semibold"}
                                          fontSize={{
                                            base: "12px",
                                            md: "16px",
                                          }}
                                        >
                                          Member Since
                                        </Text>
                                      </HStack>
                                    </Td>
                                  )}
                                  {index === 1 && (
                                    <Td px={2}>
                                      <Image
                                        src="/images/gigImage/gig-1.png"
                                        maxW="100px"
                                      />
                                    </Td>
                                  )}
                                  {index === 2 && (
                                    <Td px={2}>
                                      <Text color="red" fontWeight="medium">
                                        2h 18m due
                                      </Text>
                                    </Td>
                                  )}
                                  {index === 3 && (
                                    <Td px={2}>
                                      <Text fontWeight="semibold">Price</Text>
                                      <Text
                                        marginTop={0}
                                        color="#c5c5c5"
                                        fontWeight="semibold"
                                      >
                                        $10
                                      </Text>
                                    </Td>
                                  )}
                                  {index === 4 && (
                                    <Td px={2}>
                                      <Button bg="brand.800" color="white">
                                        2h 18m due
                                      </Button>
                                    </Td>
                                  )}
                                </Tr>
                              );
                            }
                          )}
                        </Tbody>
                      </Table>
                    </TableContainer>
                  </Box>
                </TabPanel>
              );
            })}
          </TabPanels>
        </Tabs>
      </Stack>
    </CommonContainer>
  );
}
const OrderTable = () => {
  const navigate = useNavigate();
  return (
    <TableContainer minH="150px">
      <Table>
        <Thead>
          <Tr>
            {["Buyer", "Gig", "Due On", "Total", "Status"].map(
              (item, index) => {
                return (
                  <Th
                    key={index}
                    fontWeight="medium"
                    fontSize={{ base: "16px", md: "20px" }}
                    color="#c5c5c5"
                    my={4}
                  >
                    {item}
                  </Th>
                );
              }
            )}
          </Tr>
        </Thead>
        <Tbody>
          <Tr
            cursor="pointer"
            onClick={() => {
              navigate("/freelancer/active-order");
            }}
          >
            <Td>
              <HStack>
                <Avatar src="/images/freelancer/profiles/7.png" />
                <Text fontWeight={"semibold"}>Member Since</Text>
              </HStack>
            </Td>
            <Td>
              <Image src="/images/gigImage/gig-1.png" maxW="100px" />
            </Td>
            <Td>
              <Text color="red" fontWeight="medium">
                2h 18m due
              </Text>
            </Td>
            <Td>
              <Text fontWeight="semibold">Price</Text>
              <Text marginTop={0} color="#c5c5c5" fontWeight="semibold">
                $10
              </Text>
            </Td>
            <Td>
              <Button bg="brand.800" color="white">
                2h 18m due
              </Button>
            </Td>
          </Tr>
          <Tr
            cursor="pointer"
            onClick={() => {
              navigate("/freelancer/active-order");
            }}
          >
            <Td>
              <HStack>
                <Avatar src="/images/freelancer/profiles/5.png" />
                <Text fontWeight={"semibold"}>Member Since</Text>
              </HStack>
            </Td>
            <Td>
              <Image src="/images/gigImage/gig-1.png" maxW="100px" />
            </Td>
            <Td>
              <Text color="red" fontWeight="medium">
                2h 18m due
              </Text>
            </Td>
            <Td>
              <Text fontWeight="semibold">Price</Text>
              <Text marginTop={0} color="#c5c5c5" fontWeight="semibold">
                $10
              </Text>
            </Td>
            <Td>
              <Button bg="brand.800" color="white">
                2h 18m due
              </Button>
            </Td>
          </Tr>
        </Tbody>
      </Table>
    </TableContainer>
  );
};
const linksData = [
  "Priority",
  "Active",
  "Late",
  "Delivered",
  "Completed",
  "Cancelled",
  "Starred",
];
